import { SidebarActive } from './sidebar';

/** NavigationInfo.Type that opens the agrivoltaic detail on the devices in no greenhouse. */
export const AGRI_UNASSIGNED_NAVIGATION_TYPE = 'agri-unassigned';
/** An intrusion site opened on one of its alarms: Id is the alarm. */
export const INTRUSION_EVENT_NAVIGATION_TYPE = 'intrusion-event';

export interface NavigationInfo {
  Id?: string,
  Back?: boolean,
  Type?: string,
  BackRoute?: string,
  SidebarActive?: SidebarActive,
  /** Opens a video page at this moment (epoch ms): the VMS on an alarm. */
  AtMs?: number,
  /** The kind of event at AtMs (a DEVICE_EVENTS key), marked on the VMS timeline. */
  AtType?: string
}
